import React from 'react';
import { PhoneCall, Mail, MapPin, ChevronRight, Facebook, Instagram, Youtube } from 'lucide-react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.svg';

const Footer = () => {
  return (
    <footer className="bg-swastik-blue text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img src={logo} alt="Shri Varaham Swastik Logo" className="h-12 w-auto mb-4" />
            <p className="text-white/80 mb-4">
              Providing natural healing solutions through traditional Ayurvedic practices and modern naturopathy.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.facebook.com/logesh.pdl?mibextid=ZbWKwL" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="bg-white/10 p-2 rounded-full hover:bg-white/20 transition-colors"
              >
                <Facebook size={20} className="text-white" />
              </a>
              <a 
                href="https://www.instagram.com/svsynclinic/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="bg-white/10 p-2 rounded-full hover:bg-white/20 transition-colors"
              >
                <Instagram size={20} className="text-white" />
              </a>
              <a 
                href="https://www.youtube.com/@shrivarahamswastik4862" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="bg-white/10 p-2 rounded-full hover:bg-white/20 transition-colors"
              >
                <Youtube size={20} className="text-white" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-white/80 hover:text-white flex items-center">
                  <ChevronRight size={16} className="mr-1" />
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-white/80 hover:text-white flex items-center">
                  <ChevronRight size={16} className="mr-1" />
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/treatments" className="text-white/80 hover:text-white flex items-center">
                  <ChevronRight size={16} className="mr-1" />
                  Treatments
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/80 hover:text-white flex items-center">
                  <ChevronRight size={16} className="mr-1" />
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <MapPin className="h-5 w-5 mr-3 mt-1 text-white/80" />
                <span className="text-white/80">
                  #250/42, 2nd Street, TNHB Colony,<br />
                  (Near Canara Bank)<br />
                  Korattur, Chennai - 600 080
                </span>
              </li>
              <li className="flex items-center">
                <PhoneCall className="h-5 w-5 mr-3 text-white/80" />
                <span className="text-white/80">+91-98401 93160, +91-6385044414</span>
              </li>
              <li className="flex items-center">
                <Mail className="h-5 w-5 mr-3 text-white/80" />
                <span className="text-white/80">shrivaraham.sync@gmail.com</span>
              </li>
            </ul>
          </div>

          {/* Working Hours */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Working Hours</h3>
            <ul className="space-y-2">
              <li className="flex justify-between">
                <span className="text-white/80">Monday - Saturday</span>
                <span className="text-white/80">9:00 AM - 8:00 PM</span>
              </li>
              <li className="flex justify-between">
                <span className="text-white/80">Sunday</span>
                <span className="text-white/80">9:00 AM - 2:00 PM</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 text-center">
          <p className="text-white/60">
            © {new Date().getFullYear()} Shri Varaham Swastik Yoga & Naturopathy. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
